/*
  Video Hero Split (.vhs-video) support. Loaded from layout/theme.liquid and
  layout/password.liquid — NOT inline in the section, because on some templates
  (home included) section markup reaches the DOM in a way that never executes an
  inline <script>.

  Two jobs, with very different rules:

  1. POSTER FADE — always on. Flow Play Plus (flowplayplus.js) drives playback and
     the play/pause icons, but it knows nothing about this section's
     .video-poster-image, which sits over the video at opacity 1. Without this the
     video plays underneath a frozen poster and looks broken. Media events don't
     bubble, but they DO capture, so document-level capture listeners see
     play/pause/ended from any video regardless of who started playback — no click
     handler, nothing for Flow Play Plus to fight.

  2. PLAY/PAUSE FALLBACK — only when Flow Play Plus is absent. Two click handlers on
     the same button fight (symptom: icons swap but nothing plays), so this half
     stands down whenever flowplayplus.js is on the page.
*/
(function () {
  if (window.__tpgVhsBound) return;   // never bind twice
  window.__tpgVhsBound = true;

  function paint(video) {
    var wrap = video.closest ? video.closest('.vhs-video') : null;
    if (!wrap) return;
    var poster = wrap.querySelector('.video-poster-image');
    var on = !video.paused && !video.ended;
    wrap.classList.toggle('is-playing', on);
    if (poster) {
      /* display, not opacity: a CSS transition on this element gets perpetually
         restarted by something else writing to it, and a running transition
         overrides inline styles — so opacity:0 computed as 1 and the poster
         never visually cleared. display is not animatable, so nothing can pin it. */
      poster.style.display = on ? 'none' : '';
      poster.style.pointerEvents = on ? 'none' : '';
    }
  }

  /* ---- 1. poster fade: capture-phase media events, always active ---- */
  ['play', 'pause', 'ended'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (e.target && e.target.tagName === 'VIDEO') paint(e.target);
    }, true);
  });

  /* ---- 2. playback fallback: only without Flow Play Plus ---- */
  if (document.querySelector('script[src*="flowplayplus"]')) return;

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var overlay = e.target.closest('.vhs-video .video-play-overlay');
    if (!overlay) return;

    var wrap = overlay.closest('.vhs-video');
    var video = wrap && wrap.querySelector('video');
    if (!video) return;
    e.preventDefault();

    if (video.paused || video.ended) {
      var p = video.play();
      if (p && p.catch) p.catch(function () { video.controls = true; });  // blocked → native controls
    } else {
      video.pause();
    }
  }, false);
})();
